import { uuid } from '../ids.js';
import { applyLocal } from '../mutate.js';
import { getDeviceId } from '../meta.js';
import { recomputeCards } from '../../scheduler/recompute.js';

export async function recordReview(db, cardId, rating, durationMs, now = Date.now()) {
  const id = uuid();
  const deviceId = await getDeviceId(db);
  await applyLocal(db, 'reviewLog', id, {
    cardId,
    rating,
    kind: 'review',
    reviewedAt: now,
    durationMs: Math.max(0, Math.min(Math.round(durationMs), 10 * 60 * 1000)),
    deviceId,
    deletedAt: null,
  });
  await recomputeCards(db, [cardId]);
  return id;
}

/** Undo is a soft delete of the log, so it syncs like any other edit. */
export async function undoReview(db, logId) {
  const log = await db.reviewLogs.get(logId);
  if (!log) return;
  await applyLocal(db, 'reviewLog', logId, { deletedAt: Date.now() });
  await recomputeCards(db, [log.cardId]);
}
